import React, { useState,useRef,useEffect } from "react";
import { Container, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
//import "./login.css";

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../actions/authActions'; // यदि अभी भी उपयोग में है
import { setCredentials } from '../../features/auth/authSlice'
import { useLoginMutation } from '../../features/auth/authApiSlice'
import usePersist from '../../hooks/usePersist'
import useTitle from '../../hooks/useTitle'


const Index = () => {
  useTitle('User Login')
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState('')
  const [persist, setPersist] = usePersist()
  // ध्यान दें: `error` और `loading` Redux store से आ रहे हैं, 
  // लेकिन `useLoginMutation` से `isLoading` भी है
  const { isAuthenticated, error: reduxError, loading: reduxLoading } = useSelector((state) => state.auth); // Get authentication state
  const [err, setErr] = useState({ error: false, message: null });
  const [submitting,setSubmitting] = useState(false)
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    errors: {}
  });
  const [login, { isLoading }] = useLoginMutation() // RTK Query isLoading
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      errors: { ...formData.errors, [name]: '' }, // Clear previous errors on input change
    });
  };
  const userRef = useRef()
  const errRef = useRef()

  // यदि उपयोगकर्ता पहले से प्रमाणित है, तो रीडायरेक्ट करें
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard'); // या जहां भी आप लॉग इन उपयोगकर्ताओं को भेजना चाहते हैं
    }
  }, [isAuthenticated, navigate]);

  const handleForgotPassword = () => {
    // Add your "Forgot Password" logic here
    navigate('/forgotpassword'); // या अपना वास्तविक फ़ॉरगॉट पासवर्ड राउट
  };

  const subminHandler = async (e) => {
    e.preventDefault();

    const { username, password } = formData;
    const errors = {};

    // Validation rules
    if (!username.trim()) {
      errors.username = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(username)) {
      errors.username = 'Email is invalid';
    }

    if (!password) {
      errors.password = 'Password is required';
    } 

    // Check if there are errors
    if (Object.keys(errors).length > 0) {
      setFormData({ ...formData, errors });
      return;
    }
    
    setSubmitting(true) // सबमिटिंग स्थिति सेट करें
    setErrMsg(''); // पिछली त्रुटियों को साफ़ करें

    try {
      // ✅ login म्यूटेशन से token और user दोनों को डीस्ट्रक्चर करें
      const { token, user } = await login({ username, password }).unwrap()
      console.log('Access Token:', token);
      console.log('User Data:', user); // उपयोगकर्ता डेटा लॉग करें
      
      // ✅ token और user दोनों को setCredentials में डिस्पैच करें
      dispatch(setCredentials({ token, user }));
      
      navigate('/dashboard'); // सफलता पर रीडायरेक्ट करें
    } catch (err) {
      console.log('Login Error:', err);
      if (!err.status) {
          setErrMsg('No Server Response');
      } else if (err.status === 400) {
          setErrMsg('Missing Username or Password');
      } else if (err.status === 401) {
          setErrMsg('Unauthorized');
      } else {
          setErrMsg(err.data?.message); // बैकएंड से विशिष्ट त्रुटि संदेश
      }
      // यदि errRef मौजूद है, तो उस पर फ़ोकस करें
      errRef.current?.focus(); 
      setSubmitting(false); // सबमिटिंग स्थिति रीसेट करें
    }
  }

  const handleToggle = () => setPersist(prev => !prev)
  
  const { errors } = formData;

  return (
    <div className="auth-container-new mt-5">
      <Container>
        <Row className="justify-content-md-center">
          <Col xs={12} md={4}>
            <Card className="mt-5 shadow">
              <Card.Body>
                <Card.Title className="text-center site-color-dark-red h2 mb-4">Login</Card.Title>
                {/* त्रुटि संदेश */}
                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
                  {errMsg}
                </p>
                {/* Redux error (यदि कोई हो) */}
                {reduxError && <p className="error text-center">{reduxError}</p>} 

                <Form onSubmit={subminHandler}>
                  <Form.Group controlId="formBasicEmail" className="form-group">
                    <FontAwesomeIcon icon={faEnvelope} className="form-icon" />
                    <Form.Control 
                      type="email" 
                      placeholder="Enter email" 
                      name="username" 
                      value={formData.username}
                      onChange={handleInputChange} 
                      required // HTML5 validation
                    />
                  </Form.Group>
                  {errors.username && <span className="error">{errors.username}</span>}

                  <Form.Group controlId="formBasicPassword" className="form-group">
                    <FontAwesomeIcon icon={faLock} className="form-icon" />
                    <Form.Control 
                      type="password" 
                      name="password" 
                      placeholder="Password" 
                      value={formData.password}
                      onChange={handleInputChange} 
                      required // HTML5 validation
                    />
                  </Form.Group>
                  {errors.password && <span className="error">{errors.password}</span>}

                  <div className="form-group">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      className="form-btn"
                      disabled={isLoading || submitting} // RTK Query isLoading और submitting state दोनों का उपयोग करें
                    >
                      Login {isLoading || submitting ? ( // दोनों लोडिंग स्थितियों के लिए स्पिनर
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                    </Button>
                  </div>
                  
                  {/* <label htmlFor="persist" className="form__persist ">
                    <input
                        type="checkbox"
                        className="form__checkbox"
                        id="persist"
                        onChange={handleToggle}
                        checked={persist}
                    />
                    Trust This Device
                  </label> */}
                </Form>

                <div className="link mt-4 text-center">
                  <Link to="/forgotpassword" >Forgot Password?</Link>
                </div>
                <div className="text-center mt-3">
                  <p>Don't have an account? <Link to="/registration">Sign Up</Link></p>
                </div>
                {/* यहां केवल Redux error प्रदर्शित करें, क्योंकि errMsg अधिक विशिष्ट होगा */}
                {/* {reduxError != null ? (<p className="error text-center">{reduxError}</p>) : null} */} 
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Index;
